export function formatTileData(tile) {
    const formattedData = {};

    if (tile.data.length > 0) {
        tile.data.forEach(item => {
            Object.keys(item).forEach(key => {
                formattedData[key] = item[key];
            });
        });
    }
  
    return {
        ...tile,
        data: formattedData
    };
}